import React from 'react';
const Icon = (props: React.SVGProps<SVGSVGElement>) =>
(
  <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg"
    {...props} >
    <path d="M7.00033 14.6668C7.00033 14.6668 12.3337 12.0002 12.3337 8.00016V3.3335L7.00033 1.3335L1.66699 3.3335V8.00016C1.66699 12.0002 7.00033 14.6668 7.00033 14.6668Z"
      stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default Icon;